<template>
    <Job :model="model" />
</template>

<script>
import Job from '@/components/Pages/Job';

export default {
    name: 'JobPage',
    components: {
        Job,
    },
    async asyncData({ params, $axios, error, i18n, redirect, localePath, $getIsLangKoZhDe }) {
        if ($getIsLangKoZhDe()) {
            return redirect(localePath('/'));
        }

        let model = null;

        try {
            await $axios
                .$get(`/job/by-slug/${params.job}`)
                .then((res) => {
                    if (res.success === 1) {
                        model = res.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
        }

        if (!model) {
            return error({ statusCode: 404, message: i18n.t('error.page_not_found.title') });
        }

        return { model };
    },
    head() {
        return {
            title: this.model.title,
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.$getOgTitle(this.model.title),
                },
                {
                    hid: 'title',
                    name: 'title',
                    content: this.$getOgTitle(this.model.title),
                },
                {
                    property: 'article:published_time',
                    content: this.$dayjs(this.model.created_at * 1000).format('YYYY-MM-DD'),
                },
                {
                    name: 'publish-date',
                    content: this.$dayjs(this.model.created_at * 1000).format('YYYY-MM-DD'),
                },
            ],
        };
    },
};
</script>

<style scoped></style>
